import { render, staticRenderFns } from "./aboutPage.vue?vue&type=template&id=4719d284&scoped=true"
import script from "./aboutPage.vue?vue&type=script&lang=js"
export * from "./aboutPage.vue?vue&type=script&lang=js"
import style0 from "./aboutPage.vue?vue&type=style&index=0&id=4719d284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4719d284",
  null
  
)

export default component.exports